import { Reducer } from "redux";
import { DropdownItemProps } from "semantic-ui-react";
import {
    SET_USER,
    CLEAR_USER,
    SET_LANGUAGE,
    AuthentificationActionType,
    UserData,
    UserRole,
    CLEAR_PASSWORD_RECOVERY_TOKEN,
} from "../actions/authentificationActions";

const savedState: UserData | null =
    sessionStorage.getItem("user") !== null
        ? JSON.parse(sessionStorage.getItem("user") || "")
        : null;

const initialState: UserData = {
    guid: undefined,
    username: undefined,
    firstName: undefined,
    lastName: undefined,
    token: undefined,
    role: undefined,
    language: "de",
    authority: "",
};

export const userRoleOptions: DropdownItemProps[] = [
    { key: UserRole.OfficeUser, text: "officeUser", value: UserRole.OfficeUser },
    {
        key: UserRole.EnforcementAuthorityUser,
        text: "enforcementAuthorityUser",
        value: UserRole.EnforcementAuthorityUser,
    },
    { key: UserRole.PowerUser, text: "powerUser", value: UserRole.PowerUser },
    { key: UserRole.OfficeUserViadonau, text: "officeUserViadonau", value: UserRole.OfficeUserViadonau },
];

export const userAuthorityOptions: DropdownItemProps[] = [
    { key: "AT01", text: "AT01", value: "AT01" },
    { key: "AT02", text: "AT02", value: "AT02" },
    { key: "AT03", text: "AT03", value: "AT03" },
    { key: "AT90", text: "AT90", value: "AT90", disabled: true },
];

export const userReducer: Reducer<UserData> = (
    state: UserData = savedState || initialState,
    action: AuthentificationActionType
): UserData => {
    switch (action.type) {
        case SET_USER:
            return { ...action.user };
        case CLEAR_USER:
            return { ...initialState };
        case SET_LANGUAGE:
            return { ...state, language: action.language };
        case CLEAR_PASSWORD_RECOVERY_TOKEN:
            return { ...state, passwordRecoveryToken: undefined };
        default:
            return state;
    }
};

export default userReducer;
